
import { Component, Vue, Prop } from 'nuxt-property-decorator'

@Component
export default class BlackFridayMoreDeals extends Vue {
  @Prop({
    required: false,
    default: false,
    type: Boolean,
  })
  readonly centered!: boolean
}
